import { useState, useEffect } from 'react'
import dial_answer from '../images/png/dial_answer.png'
import dial_decline from '../images/png/dial_decline.png'
import { animated, useSpring } from 'react-spring'

const DialButton = ({type}) => {
    const [buttonHovered, setButtonHovered] = useState(false)

    useEffect(() => {
        if (!buttonHovered) return

        const timeout = setTimeout(() => {
            setButtonHovered(false)
        }, 150)

        return (() => {
            clearTimeout(timeout)
        })
    }, [buttonHovered])

    const buttonAnimation = useSpring(
        {
            transform: buttonHovered ? 'rotate(10deg) scale(1.1)' : 'rotate(0deg) scale(1)',
            width: '40%',
            config: {
                tension: 300,
                friction: 10
            }
        }
    )
    
    return(
        <animated.img style={buttonAnimation}
            onMouseEnter={() => setButtonHovered(true)}
            src={type === 'answer' ? dial_answer : dial_decline}
            alt={type === 'answer' ? "vastaa puheluun" : "hylkää puhelu"}/>
    )
}

export default DialButton